'use strict';

require("core-js/modules/es6.string.sup");

require("core-js/modules/es6.string.sub");

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.fill");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var React = require('react');

var React__default = _interopDefault(React);

var styled = require('styled-components');

var styled__default = _interopDefault(styled);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */


var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};

var merge = function merge(a, b) {
  var result = objectAssign({}, a, b);

  for (var key in a) {
    var _assign;

    if (!a[key] || typeof b[key] !== 'object') continue;
    objectAssign(result, (_assign = {}, _assign[key] = objectAssign(a[key], b[key]), _assign));
  }

  return result;
}; // sort object-value responsive styles


var sort = function sort(obj) {
  var next = {};
  Object.keys(obj).sort(function (a, b) {
    return a.localeCompare(b, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }).forEach(function (key) {
    next[key] = obj[key];
  });
  return next;
};

var defaults = {
  breakpoints: [40, 52, 64].map(function (n) {
    return n + 'em';
  })
};

var createMediaQuery = function createMediaQuery(n) {
  return "@media screen and (min-width: " + n + ")";
};

var getValue = function getValue(n, scale) {
  return get(scale, n, n);
};

var get = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};

var createParser = function createParser(config) {
  var cache = {};

  var parse = function parse(props) {
    var styles = {};
    var shouldSort = false;
    var isCacheDisabled = props.theme && props.theme.disableStyledSystemCache;

    for (var key in props) {
      if (!config[key]) continue;
      var sx = config[key];
      var raw = props[key];
      var scale = get(props.theme, sx.scale, sx.defaults);

      if (typeof raw === 'object') {
        cache.breakpoints = !isCacheDisabled && cache.breakpoints || get(props.theme, 'breakpoints', defaults.breakpoints);

        if (Array.isArray(raw)) {
          cache.media = !isCacheDisabled && cache.media || [null].concat(cache.breakpoints.map(createMediaQuery));
          styles = merge(styles, parseResponsiveStyle(cache.media, sx, scale, raw, props));
          continue;
        }

        if (raw !== null) {
          styles = merge(styles, parseResponsiveObject(cache.breakpoints, sx, scale, raw, props));
          shouldSort = true;
        }

        continue;
      }

      objectAssign(styles, sx(raw, scale, props));
    } // sort object-based responsive styles


    if (shouldSort) {
      styles = sort(styles);
    }

    return styles;
  };

  parse.config = config;
  parse.propNames = Object.keys(config);
  parse.cache = cache;
  var keys = Object.keys(config).filter(function (k) {
    return k !== 'config';
  });

  if (keys.length > 1) {
    keys.forEach(function (key) {
      var _createParser;

      parse[key] = createParser((_createParser = {}, _createParser[key] = config[key], _createParser));
    });
  }

  return parse;
};

var parseResponsiveStyle = function parseResponsiveStyle(mediaQueries, sx, scale, raw, _props) {
  var styles = {};
  raw.slice(0, mediaQueries.length).forEach(function (value, i) {
    var media = mediaQueries[i];
    var style = sx(value, scale, _props);

    if (!media) {
      objectAssign(styles, style);
    } else {
      var _assign2;

      objectAssign(styles, (_assign2 = {}, _assign2[media] = objectAssign({}, styles[media], style), _assign2));
    }
  });
  return styles;
};

var parseResponsiveObject = function parseResponsiveObject(breakpoints, sx, scale, raw, _props) {
  var styles = {};

  for (var key in raw) {
    var breakpoint = breakpoints[key];
    var value = raw[key];
    var style = sx(value, scale, _props);

    if (!breakpoint) {
      objectAssign(styles, style);
    } else {
      var _assign3;

      var media = createMediaQuery(breakpoint);
      objectAssign(styles, (_assign3 = {}, _assign3[media] = objectAssign({}, styles[media], style), _assign3));
    }
  }

  return styles;
};

var createStyleFunction = function createStyleFunction(_ref) {
  var properties = _ref.properties,
      property = _ref.property,
      scale = _ref.scale,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? getValue : _ref$transform,
      defaultScale = _ref.defaultScale;
  properties = properties || [property];

  var sx = function sx(value, scale, _props) {
    var result = {};
    var n = transform(value, scale, _props);
    if (n === null) return;
    properties.forEach(function (prop) {
      result[prop] = n;
    });
    return result;
  };

  sx.scale = scale;
  sx.defaults = defaultScale;
  return sx;
}; // new v5 API


var system = function system(args) {
  if (args === void 0) {
    args = {};
  }

  var config = {};
  Object.keys(args).forEach(function (key) {
    var conf = args[key];

    if (conf === true) {
      // shortcut definition
      config[key] = createStyleFunction({
        property: key,
        scale: key
      });
      return;
    }

    if (typeof conf === 'function') {
      config[key] = conf;
      return;
    }

    config[key] = createStyleFunction(conf);
  });
  var parser = createParser(config);
  return parser;
};

var compose = function compose() {
  var config = {};

  for (var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) {
    parsers[_key] = arguments[_key];
  }

  parsers.forEach(function (parser) {
    if (!parser || !parser.config) return;
    objectAssign(config, parser.config);
  });
  var parser = createParser(config);
  return parser;
};

var isNumber = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var getWidth = function getWidth(n, scale) {
  return get(scale, n, !isNumber(n) || n > 1 ? n : n * 100 + '%');
};

var config = {
  width: {
    property: 'width',
    scale: 'sizes',
    transform: getWidth
  },
  height: {
    property: 'height',
    scale: 'sizes'
  },
  minWidth: {
    property: 'minWidth',
    scale: 'sizes'
  },
  minHeight: {
    property: 'minHeight',
    scale: 'sizes'
  },
  maxWidth: {
    property: 'maxWidth',
    scale: 'sizes'
  },
  maxHeight: {
    property: 'maxHeight',
    scale: 'sizes'
  },
  size: {
    properties: ['width', 'height'],
    scale: 'sizes'
  },
  overflow: true,
  overflowX: true,
  overflowY: true,
  display: true,
  verticalAlign: true
};
var layout = system(config);
var config$1 = {
  color: {
    property: 'color',
    scale: 'colors'
  },
  backgroundColor: {
    property: 'backgroundColor',
    scale: 'colors'
  },
  opacity: true
};
config$1.bg = config$1.backgroundColor;
var color = system(config$1);
var defaults$1 = {
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var config$2 = {
  fontFamily: {
    property: 'fontFamily',
    scale: 'fonts'
  },
  fontSize: {
    property: 'fontSize',
    scale: 'fontSizes',
    defaultScale: defaults$1.fontSizes
  },
  fontWeight: {
    property: 'fontWeight',
    scale: 'fontWeights'
  },
  lineHeight: {
    property: 'lineHeight',
    scale: 'lineHeights'
  },
  letterSpacing: {
    property: 'letterSpacing',
    scale: 'letterSpacings'
  },
  textAlign: true,
  fontStyle: true
};
var typography = system(config$2);
var config$3 = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  // item
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  justifySelf: true,
  alignSelf: true,
  order: true
};
var flexbox = system(config$3);
var defaults$2 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var config$4 = {
  gridGap: {
    property: 'gridGap',
    scale: 'space',
    defaultScale: defaults$2.space
  },
  gridColumnGap: {
    property: 'gridColumnGap',
    scale: 'space',
    defaultScale: defaults$2.space
  },
  gridRowGap: {
    property: 'gridRowGap',
    scale: 'space',
    defaultScale: defaults$2.space
  },
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridAutoRows: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
};
var grid = system(config$4);

var _config;

var config$5 = (_config = {
  border: {
    property: 'border',
    scale: 'borders'
  },
  borderWidth: {
    property: 'borderWidth',
    scale: 'borderWidths'
  },
  borderStyle: {
    property: 'borderStyle',
    scale: 'borderStyles'
  },
  borderColor: {
    property: 'borderColor',
    scale: 'colors'
  },
  borderRadius: {
    property: 'borderRadius',
    scale: 'radii'
  },
  borderTop: {
    property: 'borderTop',
    scale: 'borders'
  },
  borderTopLeftRadius: {
    property: 'borderTopLeftRadius',
    scale: 'radii'
  },
  borderTopRightRadius: {
    property: 'borderTopRightRadius',
    scale: 'radii'
  },
  borderRight: {
    property: 'borderRight',
    scale: 'borders'
  },
  borderBottom: {
    property: 'borderBottom',
    scale: 'borders'
  },
  borderBottomLeftRadius: {
    property: 'borderBottomLeftRadius',
    scale: 'radii'
  },
  borderBottomRightRadius: {
    property: 'borderBottomRightRadius',
    scale: 'radii'
  },
  borderLeft: {
    property: 'borderLeft',
    scale: 'borders'
  },
  borderX: {
    properties: ['borderLeft', 'borderRight'],
    scale: 'borders'
  },
  borderY: {
    properties: ['borderTop', 'borderBottom'],
    scale: 'borders'
  },
  borderTopWidth: {
    property: 'borderTopWidth',
    scale: 'borderWidths'
  },
  borderTopColor: {
    property: 'borderTopColor',
    scale: 'colors'
  },
  borderTopStyle: {
    property: 'borderTopStyle',
    scale: 'borderStyles'
  }
}, _config["borderTopLeftRadius"] = {
  property: 'borderTopLeftRadius',
  scale: 'radii'
}, _config["borderTopRightRadius"] = {
  property: 'borderTopRightRadius',
  scale: 'radii'
}, _config.borderBottomWidth = {
  property: 'borderBottomWidth',
  scale: 'borderWidths'
}, _config.borderBottomColor = {
  property: 'borderBottomColor',
  scale: 'colors'
}, _config.borderBottomStyle = {
  property: 'borderBottomStyle',
  scale: 'borderStyles'
}, _config["borderBottomLeftRadius"] = {
  property: 'borderBottomLeftRadius',
  scale: 'radii'
}, _config["borderBottomRightRadius"] = {
  property: 'borderBottomRightRadius',
  scale: 'radii'
}, _config.borderLeftWidth = {
  property: 'borderLeftWidth',
  scale: 'borderWidths'
}, _config.borderLeftColor = {
  property: 'borderLeftColor',
  scale: 'colors'
}, _config.borderLeftStyle = {
  property: 'borderLeftStyle',
  scale: 'borderStyles'
}, _config.borderRightWidth = {
  property: 'borderRightWidth',
  scale: 'borderWidths'
}, _config.borderRightColor = {
  property: 'borderRightColor',
  scale: 'colors'
}, _config.borderRightStyle = {
  property: 'borderRightStyle',
  scale: 'borderStyles'
}, _config);
var border = system(config$5);
var config$6 = {
  background: true,
  backgroundImage: true,
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true
};
config$6.bgImage = config$6.backgroundImage;
config$6.bgSize = config$6.backgroundSize;
config$6.bgPosition = config$6.backgroundPosition;
config$6.bgRepeat = config$6.backgroundRepeat;
var background = system(config$6);
var defaults$3 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var config$7 = {
  position: true,
  zIndex: {
    property: 'zIndex',
    scale: 'zIndices'
  },
  top: {
    property: 'top',
    scale: 'space',
    defaultScale: defaults$3.space
  },
  right: {
    property: 'right',
    scale: 'space',
    defaultScale: defaults$3.space
  },
  bottom: {
    property: 'bottom',
    scale: 'space',
    defaultScale: defaults$3.space
  },
  left: {
    property: 'left',
    scale: 'space',
    defaultScale: defaults$3.space
  }
};
var position = system(config$7);
var defaults$4 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};

var isNumber$1 = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var getMargin = function getMargin(n, scale) {
  if (!isNumber$1(n)) {
    return get(scale, n, n);
  }

  var isNegative = n < 0;
  var absolute = Math.abs(n);
  var value = get(scale, absolute, absolute);

  if (!isNumber$1(value)) {
    return isNegative ? '-' + value : value;
  }

  return value * (isNegative ? -1 : 1);
};

var configs = {};
configs.margin = {
  margin: {
    property: 'margin',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults$4.space
  },
  marginTop: {
    property: 'marginTop',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults$4.space
  },
  marginRight: {
    property: 'marginRight',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults$4.space
  },
  marginBottom: {
    property: 'marginBottom',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults$4.space
  },
  marginLeft: {
    property: 'marginLeft',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults$4.space
  },
  marginX: {
    properties: ['marginLeft', 'marginRight'],
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults$4.space
  },
  marginY: {
    properties: ['marginTop', 'marginBottom'],
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults$4.space
  }
};
configs.margin.m = configs.margin.margin;
configs.margin.mt = configs.margin.marginTop;
configs.margin.mr = configs.margin.marginRight;
configs.margin.mb = configs.margin.marginBottom;
configs.margin.ml = configs.margin.marginLeft;
configs.margin.mx = configs.margin.marginX;
configs.margin.my = configs.margin.marginY;
configs.padding = {
  padding: {
    property: 'padding',
    scale: 'space',
    defaultScale: defaults$4.space
  },
  paddingTop: {
    property: 'paddingTop',
    scale: 'space',
    defaultScale: defaults$4.space
  },
  paddingRight: {
    property: 'paddingRight',
    scale: 'space',
    defaultScale: defaults$4.space
  },
  paddingBottom: {
    property: 'paddingBottom',
    scale: 'space',
    defaultScale: defaults$4.space
  },
  paddingLeft: {
    property: 'paddingLeft',
    scale: 'space',
    defaultScale: defaults$4.space
  },
  paddingX: {
    properties: ['paddingLeft', 'paddingRight'],
    scale: 'space',
    defaultScale: defaults$4.space
  },
  paddingY: {
    properties: ['paddingTop', 'paddingBottom'],
    scale: 'space',
    defaultScale: defaults$4.space
  }
};
configs.padding.p = configs.padding.padding;
configs.padding.pt = configs.padding.paddingTop;
configs.padding.pr = configs.padding.paddingRight;
configs.padding.pb = configs.padding.paddingBottom;
configs.padding.pl = configs.padding.paddingLeft;
configs.padding.px = configs.padding.paddingX;
configs.padding.py = configs.padding.paddingY;
var margin = system(configs.margin);
var padding = system(configs.padding);
var space = compose(margin, padding);
var shadow = system({
  boxShadow: {
    property: 'boxShadow',
    scale: 'shadows'
  },
  textShadow: {
    property: 'textShadow',
    scale: 'shadows'
  }
});

var _scales;

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
} // based on https://github.com/developit/dlv


var get$1 = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};

var defaultBreakpoints = [40, 52, 64].map(function (n) {
  return n + 'em';
});
var defaultTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var aliases = {
  bg: 'backgroundColor',
  m: 'margin',
  mt: 'marginTop',
  mr: 'marginRight',
  mb: 'marginBottom',
  ml: 'marginLeft',
  mx: 'marginX',
  my: 'marginY',
  p: 'padding',
  pt: 'paddingTop',
  pr: 'paddingRight',
  pb: 'paddingBottom',
  pl: 'paddingLeft',
  px: 'paddingX',
  py: 'paddingY'
};
var multiples = {
  marginX: ['marginLeft', 'marginRight'],
  marginY: ['marginTop', 'marginBottom'],
  paddingX: ['paddingLeft', 'paddingRight'],
  paddingY: ['paddingTop', 'paddingBottom'],
  size: ['width', 'height']
};
var scales = (_scales = {
  color: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  margin: 'space',
  marginTop: 'space',
  marginRight: 'space',
  marginBottom: 'space',
  marginLeft: 'space',
  marginX: 'space',
  marginY: 'space',
  padding: 'space',
  paddingTop: 'space',
  paddingRight: 'space',
  paddingBottom: 'space',
  paddingLeft: 'space',
  paddingX: 'space',
  paddingY: 'space',
  top: 'space',
  right: 'space',
  bottom: 'space',
  left: 'space',
  gridGap: 'space',
  gridColumnGap: 'space',
  gridRowGap: 'space',
  gap: 'space',
  columnGap: 'space',
  rowGap: 'space',
  fontFamily: 'fonts',
  fontSize: 'fontSizes',
  fontWeight: 'fontWeights',
  lineHeight: 'lineHeights',
  letterSpacing: 'letterSpacings',
  border: 'borders',
  borderTop: 'borders',
  borderRight: 'borders',
  borderBottom: 'borders',
  borderLeft: 'borders',
  borderWidth: 'borderWidths',
  borderStyle: 'borderStyles',
  borderRadius: 'radii',
  borderTopRightRadius: 'radii',
  borderTopLeftRadius: 'radii',
  borderBottomRightRadius: 'radii',
  borderBottomLeftRadius: 'radii',
  borderTopWidth: 'borderWidths',
  borderTopColor: 'colors',
  borderTopStyle: 'borderStyles'
}, _scales["borderTopLeftRadius"] = 'radii', _scales["borderTopRightRadius"] = 'radii', _scales.borderBottomWidth = 'borderWidths', _scales.borderBottomColor = 'colors', _scales.borderBottomStyle = 'borderStyles', _scales["borderBottomLeftRadius"] = 'radii', _scales["borderBottomRightRadius"] = 'radii', _scales.borderLeftWidth = 'borderWidths', _scales.borderLeftColor = 'colors', _scales.borderLeftStyle = 'borderStyles', _scales.borderRightWidth = 'borderWidths', _scales.borderRightColor = 'colors', _scales.borderRightStyle = 'borderStyles', _scales.boxShadow = 'shadows', _scales.textShadow = 'shadows', _scales.zIndex = 'zIndices', _scales.width = 'sizes', _scales.minWidth = 'sizes', _scales.maxWidth = 'sizes', _scales.height = 'sizes', _scales.minHeight = 'sizes', _scales.maxHeight = 'sizes', _scales.flexBasis = 'sizes', _scales.size = 'sizes', _scales.fill = 'colors', _scales.stroke = 'colors', _scales);

var positiveOrNegative = function positiveOrNegative(scale, value) {
  if (typeof value !== 'number' || value >= 0) {
    return get$1(scale, value, value);
  }

  var absolute = Math.abs(value);
  var n = get$1(scale, absolute, absolute);
  if (typeof n === 'string') return '-' + n;
  return n * -1;
};

var transforms = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'top', 'bottom', 'left', 'right'].reduce(function (acc, curr) {
  var _extends2;

  return _extends$1({}, acc, (_extends2 = {}, _extends2[curr] = positiveOrNegative, _extends2));
}, {});

var responsive = function responsive(styles) {
  return function (theme) {
    var next = {};
    var breakpoints = get$1(theme, 'breakpoints', defaultBreakpoints);
    var mediaQueries = [null].concat(breakpoints.map(function (n) {
      return "@media screen and (min-width: " + n + ")";
    }));

    for (var key in styles) {
      var value = typeof styles[key] === 'function' ? styles[key](theme) : styles[key];
      if (value == null) continue;

      if (!Array.isArray(value)) {
        next[key] = value;
        continue;
      }

      for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
        var media = mediaQueries[i];
        if (value[i] == null) continue;

        if (!media) {
          next[key] = value[i];
          continue;
        }

        next[media] = next[media] || {};
        next[media][key] = value[i];
      }
    }

    return next;
  };
};

var css = function css(args) {
  return function (props) {
    if (props === void 0) {
      props = {};
    }

    var theme = _extends$1({}, defaultTheme, {}, props.theme || props);

    var result = {};
    var obj = typeof args === 'function' ? args(theme) : args;
    var styles = responsive(obj)(theme);

    for (var key in styles) {
      var x = styles[key];
      var val = typeof x === 'function' ? x(theme) : x;

      if (key === 'variant') {
        var variant = css(get$1(theme, val))(theme);
        result = _extends$1({}, result, {}, variant);
        continue;
      }

      if (val && typeof val === 'object') {
        result[key] = css(val)(theme);
        continue;
      }

      var prop = get$1(aliases, key, key);
      var scaleName = get$1(scales, prop);
      var scale = get$1(theme, scaleName, get$1(theme, prop, {}));
      var transform = get$1(transforms, prop, get$1);
      var value = transform(scale, val, val);

      if (multiples[prop]) {
        var dirs = multiples[prop];

        for (var i = 0; i < dirs.length; i++) {
          result[dirs[i]] = value;
        }
      } else {
        result[prop] = value;
      }
    }

    return result;
  };
};

var variant = function variant(_ref) {
  var _config;

  var scale = _ref.scale,
      _ref$prop = _ref.prop,
      prop = _ref$prop === void 0 ? 'variant' : _ref$prop,
      _ref$variants = _ref.variants,
      variants = _ref$variants === void 0 ? {} : _ref$variants,
      key = _ref.key;
  var sx;

  if (Object.keys(variants).length) {
    sx = function sx(value, scale, props) {
      return css(get(scale, value, null))(props.theme);
    };
  } else {
    sx = function sx(value, scale) {
      return get(scale, value, null);
    };
  }

  sx.scale = scale || key;
  sx.defaults = variants;
  var config = (_config = {}, _config[prop] = sx, _config);
  var parser = createParser(config);
  return parser;
};

var buttonStyle = variant({
  key: 'buttons'
});
var textStyle = variant({
  key: 'textStyles',
  prop: 'textStyle'
});
var colorStyle = variant({
  key: 'colorStyles',
  prop: 'colors'
});

var style = function style(_ref) {
  var prop = _ref.prop,
      cssProperty = _ref.cssProperty,
      alias = _ref.alias,
      key = _ref.key,
      transformValue = _ref.transformValue,
      scale = _ref.scale,
      properties = _ref.properties;
  var config = {};
  config[prop] = createStyleFunction({
    properties: properties,
    property: cssProperty || prop,
    scale: key,
    defaultScale: scale,
    transform: transformValue
  });
  if (alias) config[alias] = config[prop];
  var parse = createParser(config);
  return parse;
};

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Box = styled__default.div(_templateObject(), compose(background, border, color, flexbox, grid, position, shadow, typography, layout), system({
  p: {
    property: "padding",
    scale: "spacing"
  },
  pt: {
    property: "paddingTop",
    scale: "spacing"
  },
  pr: {
    property: "paddingRight",
    scale: "spacing"
  },
  pb: {
    property: "paddingBottom",
    scale: "spacing"
  },
  pl: {
    property: "paddingLeft",
    scale: "spacing"
  },
  px: {
    properties: ["paddingLeft", "paddingRight"],
    scale: "spacing"
  },
  py: {
    properties: ["paddingTop", "paddingBottom"],
    scale: "spacing"
  },
  m: {
    property: "margin",
    scale: "spacing",
    defaultScale: "spacing"
  },
  mt: {
    property: "marginTop",
    scale: "spacing"
  },
  mr: {
    property: "marginRight",
    scale: "spacing"
  },
  mb: {
    property: "marginBottom",
    scale: "spacing"
  },
  ml: {
    property: "marginLeft",
    scale: "spacing"
  },
  mx: {
    properties: ["marginLeft", "marginRight"],
    scale: "spacing"
  },
  my: {
    properties: ["marginTop", "marginBottom"],
    scale: "spacing"
  },
  padding: {
    property: "padding",
    scale: "spacing"
  },
  paddingTop: {
    property: "paddingTop",
    scale: "spacing"
  },
  paddingRight: {
    property: "paddingRight",
    scale: "spacing"
  },
  paddingBottom: {
    property: "paddingBottom",
    scale: "spacing"
  },
  paddingLeft: {
    property: "paddingLeft",
    scale: "spacing"
  },
  paddingX: {
    properties: ["paddingLeft", "paddingRight"],
    scale: "spacing"
  },
  paddingY: {
    properties: ["paddingTop", "paddingBottom"],
    scale: "spacing"
  },
  margin: {
    property: "margin",
    scale: "spacing",
    defaultScale: "spacing"
  },
  marginTop: {
    property: "marginTop",
    scale: "spacing"
  },
  marginRight: {
    property: "marginRight",
    scale: "spacing"
  },
  marginBottom: {
    property: "marginBottom",
    scale: "spacing"
  },
  marginLeft: {
    property: "marginLeft",
    scale: "spacing"
  },
  marginX: {
    properties: ["marginLeft", "marginRight"],
    scale: "spacing"
  },
  marginY: {
    properties: ["marginTop", "marginBottom"],
    scale: "spacing"
  },
  nm: {
    property: "margin",
    scale: "negateSpacing",
    defaultScale: "negateSpacing"
  },
  nmt: {
    property: "marginTop",
    scale: "negateSpacing"
  },
  nmr: {
    property: "marginRight",
    scale: "negateSpacing"
  },
  nmb: {
    property: "marginBottom",
    scale: "negateSpacing"
  },
  nml: {
    property: "marginLeft",
    scale: "negateSpacing"
  },
  nmx: {
    properties: ["marginLeft", "marginRight"],
    scale: "negateSpacing"
  },
  nmy: {
    properties: ["marginTop", "marginBottom"],
    scale: "negateSpacing"
  },
  nmargin: {
    property: "margin",
    scale: "negateSpacing",
    defaultScale: "spacing"
  },
  nmarginTop: {
    property: "marginTop",
    scale: "negateSpacing"
  },
  nmarginRight: {
    property: "marginRight",
    scale: "negateSpacing"
  },
  nmarginBottom: {
    property: "marginBottom",
    scale: "negateSpacing"
  },
  nmarginLeft: {
    property: "marginLeft",
    scale: "negateSpacing"
  },
  nmarginX: {
    properties: ["marginLeft", "marginRight"],
    scale: "negateSpacing"
  },
  nmarginY: {
    properties: ["marginTop", "marginBottom"],
    scale: "negateSpacing"
  }
}));

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }

  shim.isRequired = shim;

  function getShim() {
    return shim;
  } // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.


  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims();
  }
});

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  /*\n  Elimina (al poner content:unset) los pseudoelementos si el usuario no\n  establece crop, topCrop o bottomCrop.\n  */\n  ", "\n\n  /* bottomCrop corta solo la parte inferior */\n  ", "\n\n  /* topCrop corta solo la parte superior */\n  ", "\n\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var caps = style({
  prop: "caps",
  cssProperty: "textTransform",
  transformValue: function transformValue(n) {
    return n ? "uppercase" : "unset";
  }
});
var ellipsis = style({
  prop: "truncate",
  cssProperty: "textOverflow",
  transformValue: function transformValue(n) {
    return n ? "ellipsis" : "unset";
  }
});
var display = style({
  prop: "truncate",
  cssProperty: "display",
  transformValue: function transformValue(n) {
    return n ? "block" : "inherit";
  }
});
var whiteSpace = style({
  prop: "truncate",
  cssProperty: "whiteSpace",
  transformValue: function transformValue(n) {
    return n ? "nowrap" : "wrap";
  }
});
var overflow = style({
  prop: "truncate",
  cssProperty: "overflow",
  transformValue: function transformValue(n) {
    return n ? "hidden" : "visible";
  }
});
var Text = styled__default(Box).attrs(function (p) {
  return {
    as: p.as || "span"
  };
})(_templateObject$1(), function (p) {
  return p.textStyle && p.theme.textStyle[p.textStyle];
}, system({
  weight: {
    property: "fontWeight",
    scale: "fontWeight"
  }
}), ellipsis, display, whiteSpace, overflow, caps, function (p) {
  return !p.crop && !p.topCrop && !p.bottomCrop && styled.css(["&::after,&:before{content:unset;margin-top:0;margin-bottom:0;}"]);
}, function (p) {
  return p.bottomCrop && !p.topCrop && styled.css(["&::before{content:unset;margin-top:0;margin-bottom:0;}"]);
}, function (p) {
  return p.topCrop && !p.bottomCrop && styled.css(["&::after{content:unset;margin-top:0;margin-bottom:0;}"]);
});
Text.propTypes = {
  textStyle: propTypes.string,
  caps: propTypes.bool,
  fontWeight: propTypes.string,
  truncate: propTypes.bool,
  crop: propTypes.bool
};

var Anchor = function Anchor(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return React__default.createElement(Text, _extends({
    as: "a"
  }, props), children);
};

var _StyledBox = styled__default(Box).withConfig({
  displayName: "Link___StyledBox",
  componentId: "sc-1exdzm0-0"
})(["cursor:", ";&:focus{color:", ";}"], function (p) {
  return p._css;
}, function (p) {
  return p.theme.color.linkHover01;
});

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  ", "\n  ", "\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var Flex = styled__default.div(_templateObject$2(), compose(background, border, color, flexbox, grid, position, shadow, typography, layout), system({
  p: {
    property: "padding",
    scale: "spacing"
  },
  pt: {
    property: "paddingTop",
    scale: "spacing"
  },
  pr: {
    property: "paddingRight",
    scale: "spacing"
  },
  pb: {
    property: "paddingBottom",
    scale: "spacing"
  },
  pl: {
    property: "paddingLeft",
    scale: "spacing"
  },
  px: {
    properties: ["paddingLeft", "paddingRight"],
    scale: "spacing"
  },
  py: {
    properties: ["paddingTop", "paddingBottom"],
    scale: "spacing"
  },
  m: {
    property: "margin",
    scale: "spacing",
    defaultScale: "spacing"
  },
  mt: {
    property: "marginTop",
    scale: "spacing"
  },
  mr: {
    property: "marginRight",
    scale: "spacing"
  },
  mb: {
    property: "marginBottom",
    scale: "spacing"
  },
  ml: {
    property: "marginLeft",
    scale: "spacing"
  },
  mx: {
    properties: ["marginLeft", "marginRight"],
    scale: "spacing"
  },
  my: {
    properties: ["marginTop", "marginBottom"],
    scale: "spacing"
  },
  padding: {
    property: "padding",
    scale: "spacing"
  },
  paddingTop: {
    property: "paddingTop",
    scale: "spacing"
  },
  paddingRight: {
    property: "paddingRight",
    scale: "spacing"
  },
  paddingBottom: {
    property: "paddingBottom",
    scale: "spacing"
  },
  paddingLeft: {
    property: "paddingLeft",
    scale: "spacing"
  },
  paddingX: {
    properties: ["paddingLeft", "paddingRight"],
    scale: "spacing"
  },
  paddingY: {
    properties: ["paddingTop", "paddingBottom"],
    scale: "spacing"
  },
  margin: {
    property: "margin",
    scale: "spacing",
    defaultScale: "spacing"
  },
  marginTop: {
    property: "marginTop",
    scale: "spacing"
  },
  marginRight: {
    property: "marginRight",
    scale: "spacing"
  },
  marginBottom: {
    property: "marginBottom",
    scale: "spacing"
  },
  marginLeft: {
    property: "marginLeft",
    scale: "spacing"
  },
  marginX: {
    properties: ["marginLeft", "marginRight"],
    scale: "spacing"
  },
  marginY: {
    properties: ["marginTop", "marginBottom"],
    scale: "spacing"
  },
  nm: {
    property: "margin",
    scale: "negateSpacing",
    defaultScale: "negateSpacing"
  },
  nmt: {
    property: "marginTop",
    scale: "negateSpacing"
  },
  nmr: {
    property: "marginRight",
    scale: "negateSpacing"
  },
  nmb: {
    property: "marginBottom",
    scale: "negateSpacing"
  },
  nml: {
    property: "marginLeft",
    scale: "negateSpacing"
  },
  nmx: {
    properties: ["marginLeft", "marginRight"],
    scale: "negateSpacing"
  },
  nmy: {
    properties: ["marginTop", "marginBottom"],
    scale: "negateSpacing"
  },
  nmargin: {
    property: "margin",
    scale: "negateSpacing",
    defaultScale: "spacing"
  },
  nmarginTop: {
    property: "marginTop",
    scale: "negateSpacing"
  },
  nmarginRight: {
    property: "marginRight",
    scale: "negateSpacing"
  },
  nmarginBottom: {
    property: "marginBottom",
    scale: "negateSpacing"
  },
  nmarginLeft: {
    property: "marginLeft",
    scale: "negateSpacing"
  },
  nmarginX: {
    properties: ["marginLeft", "marginRight"],
    scale: "negateSpacing"
  },
  nmarginY: {
    properties: ["marginTop", "marginBottom"],
    scale: "negateSpacing"
  }
}));

var MaxWidth = function MaxWidth(_ref) {
  var children = _ref.children,
      fluid = _ref.fluid,
      useContainers = _ref.useContainers,
      _ref$flexDirection = _ref.flexDirection,
      flexDirection = _ref$flexDirection === void 0 ? "column" : _ref$flexDirection,
      _ref$m = _ref.m,
      m = _ref$m === void 0 ? "auto" : _ref$m,
      width = _ref.width,
      maxWidth = _ref.maxWidth,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "fluid", "useContainers", "flexDirection", "m", "width", "maxWidth"]);

  var widths = [].concat(React.useContext(styled.ThemeContext).mediaquery.mediaqueries.map(function (i) {
    return i.container ? i.container : i.minWidth;
  }));
  return React__default.createElement(Flex, _extends({
    useContainers: useContainers,
    flexDirection: flexDirection,
    m: m,
    fluid: fluid,
    width: fluid ? "100%" : widths,
    maxWidth: fluid ? "100%" : widths
  }, props), children);
};

var swapExtension = function swapExtension(src, ext) {
  var pointSplit = src.split(".");
  pointSplit[pointSplit.length - 1] = ext;
  return pointSplit.join(".");
};

var Image = function Image(_ref) {
  var src = _ref.src,
      webp = _ref.webp,
      alt = _ref.alt,
      webpsrc = _ref.webpsrc,
      props = _objectWithoutPropertiesLoose(_ref, ["src", "webp", "alt", "webpsrc"]);

  return webpsrc ? React__default.createElement("picture", props, React__default.createElement("source", {
    srcSet: swapExtension(webpsrc, "webp"),
    type: "image/webp"
  }), React__default.createElement("source", {
    srcSet: src,
    type: "image/jpeg"
  }), React__default.createElement("img", {
    src: src,
    alt: alt
  })) : React__default.createElement("img", _extends({
    src: src,
    alt: alt
  }, props));
};
/**
 * CSS to normalize abnormalities across browsers (normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * const GlobalStyle = createGlobalStyle`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */


function normalize() {
  var _ref;

  return [(_ref = {
    html: {
      lineHeight: '1.15',
      textSizeAdjust: '100%'
    },
    body: {
      margin: '0'
    },
    h1: {
      fontSize: '2em',
      margin: '0.67em 0'
    },
    hr: {
      boxSizing: 'content-box',
      height: '0',
      overflow: 'visible'
    },
    pre: {
      fontFamily: 'monospace, monospace',
      fontSize: '1em'
    },
    a: {
      backgroundColor: 'transparent'
    },
    'abbr[title]': {
      borderBottom: 'none',
      textDecoration: 'underline'
    }
  }, _ref["b,\n    strong"] = {
    fontWeight: 'bolder'
  }, _ref["code,\n    kbd,\n    samp"] = {
    fontFamily: 'monospace, monospace',
    fontSize: '1em'
  }, _ref.small = {
    fontSize: '80%'
  }, _ref["sub,\n    sup"] = {
    fontSize: '75%',
    lineHeight: '0',
    position: 'relative',
    verticalAlign: 'baseline'
  }, _ref.sub = {
    bottom: '-0.25em'
  }, _ref.sup = {
    top: '-0.5em'
  }, _ref.img = {
    borderStyle: 'none'
  }, _ref["button,\n    input,\n    optgroup,\n    select,\n    textarea"] = {
    fontFamily: 'inherit',
    fontSize: '100%',
    lineHeight: '1.15',
    margin: '0'
  }, _ref["button,\n    input"] = {
    overflow: 'visible'
  }, _ref["button,\n    select"] = {
    textTransform: 'none'
  }, _ref["button,\n    html [type=\"button\"],\n    [type=\"reset\"],\n    [type=\"submit\"]"] = {
    WebkitAppearance: 'button'
  }, _ref["button::-moz-focus-inner,\n    [type=\"button\"]::-moz-focus-inner,\n    [type=\"reset\"]::-moz-focus-inner,\n    [type=\"submit\"]::-moz-focus-inner"] = {
    borderStyle: 'none',
    padding: '0'
  }, _ref["button:-moz-focusring,\n    [type=\"button\"]:-moz-focusring,\n    [type=\"reset\"]:-moz-focusring,\n    [type=\"submit\"]:-moz-focusring"] = {
    outline: '1px dotted ButtonText'
  }, _ref.fieldset = {
    padding: '0.35em 0.625em 0.75em'
  }, _ref.legend = {
    boxSizing: 'border-box',
    color: 'inherit',
    display: 'table',
    maxWidth: '100%',
    padding: '0',
    whiteSpace: 'normal'
  }, _ref.progress = {
    verticalAlign: 'baseline'
  }, _ref.textarea = {
    overflow: 'auto'
  }, _ref["[type=\"checkbox\"],\n    [type=\"radio\"]"] = {
    boxSizing: 'border-box',
    padding: '0'
  }, _ref["[type=\"number\"]::-webkit-inner-spin-button,\n    [type=\"number\"]::-webkit-outer-spin-button"] = {
    height: 'auto'
  }, _ref['[type="search"]'] = {
    WebkitAppearance: 'textfield',
    outlineOffset: '-2px'
  }, _ref['[type="search"]::-webkit-search-decoration'] = {
    WebkitAppearance: 'none'
  }, _ref['::-webkit-file-upload-button'] = {
    WebkitAppearance: 'button',
    font: 'inherit'
  }, _ref.details = {
    display: 'block'
  }, _ref.summary = {
    display: 'list-item'
  }, _ref.template = {
    display: 'none'
  }, _ref['[hidden]'] = {
    display: 'none'
  }, _ref), {
    'abbr[title]': {
      textDecoration: 'underline dotted'
    }
  }];
}

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n  html,\n\n  body {\n    font-family: ", ";\n    line-height: ", ";\n    font-family: ", ";\n    background-color: ", ";\n    color: ", ";\n    -webkit-font-smoothing: antialiased;\n  }\n\n  * {\n    box-sizing: border-box;\n  }\n\n  ol,\n  ul,\n  li {\n    margin: 0;\n    padding: 0;\n  }\n\n  li {\n    list-style: none;\n  }\n\n  img {\n    display: block;\n    width: 100%;\n  }\n\n  a {\n    text-decoration: none;\n  }\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var Normalize = styled.createGlobalStyle(_templateObject$3(), normalize(), function (p) {
  return p.theme.fontFamily.primary;
}, function (p) {
  return p.theme.lineHeightBase;
}, function (p) {
  return p.theme.fontFamily.primary;
}, function (p) {
  return p.theme.color.ui02;
}, function (p) {
  return p.theme.color.text01;
});

function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var SText = styled__default(Text)(_templateObject$4());

var Truncate = function Truncate(_ref) {
  var children = _ref.children,
      others = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return React__default.createElement(SText, others, children);
};

function _templateObject$5() {
  var data = _taggedTemplateLiteralLoose(["\n  /* SHAME: Margen negativo para contrarestar el margen inferior de los hijos.*/\n  ", "\n\n  & > * {\n    ", "\n\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledFlex = styled__default(Flex)(_templateObject$5(), system({
  verticalSpace: {
    property: "marginBottom",
    scale: "negateSpacing"
  },
  vs: {
    property: "marginBottom",
    scale: "negateSpacing"
  },
  space: {
    properties: ["marginBottom", "marginRight"],
    scale: "negateSpacing"
  },
  s: {
    properties: ["marginBottom", "marginRight"],
    scale: "negateSpacing"
  }
}), system({
  hs: {
    property: "marginRight",
    scale: "spacing"
  },
  vs: {
    property: "marginBottom",
    scale: "spacing"
  },
  s: {
    properties: ["marginBottom", "marginRight"],
    scale: "spacing"
  },
  horizontalSpace: {
    property: "marginRight",
    scale: "spacing"
  },
  verticalSpace: {
    property: "marginBottom",
    scale: "spacing"
  },
  space: {
    properties: ["marginBottom", "marginRight"],
    scale: "spacing"
  }
}));

var Inline = function Inline(_ref) {
  var flexWrap = _ref.flexWrap,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["flexWrap", "children"]);

  return React__default.createElement(StyledFlex, _extends({
    flexWrap: flexWrap ? flexWrap : "wrap"
  }, props), children);
};

function _templateObject$6() {
  var data = _taggedTemplateLiteralLoose(["\n  & > * + * {\n    ", "\n  }\n\n  ", "\n\n  & > *:not(._STACK_) {\n    ", "\n  }\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledStack = styled__default(Flex)(_templateObject$6(), system({
  vsr: {
    property: "marginBottom",
    scale: "spacing"
  },
  vs: {
    property: "marginTop",
    scale: "spacing"
  },
  hs: {
    property: "marginLeft",
    scale: "spacing"
  },
  hsr: {
    property: "marginRight",
    scale: "spacing"
  }
}), function (p) {
  return p.debug && styled.css(["border:1px dashed ", ";background-color:", ";"], p.debugBorder, p.debugColor ? p.debugColor : "lightpink");
}, function (p) {
  return p.debug && styled.css(["background-color:", ";"], function (p) {
    return p.theme.color.inverse01;
  });
});

var Stack = function Stack(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return React__default.createElement(StyledStack, _extends({
    className: "_STACK_"
  }, props), children);
};

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$7() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}

var SFlex = styled__default(Flex)(_templateObject$7(), system({
  vs: {
    property: "marginTop",
    scale: "negateHalfSpacing"
  },
  hs: {
    properties: ["marginLeft", "marginRight"],
    scale: "negateHalfSpacing"
  }
}));
var SBox = styled__default(Box)(_templateObject2(), system({
  gutter: {
    properties: ["paddingLeft", "paddingRight"],
    scale: "halfSpacing"
  }
}));

var StackBox = function StackBox(_ref) {
  var vs = _ref.vs,
      hs = _ref.hs,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["vs", "hs", "children"]);

  return React__default.createElement(SFlex, _extends({
    vs: vs,
    hs: hs
  }, props), React__default.Children.map(children, function (el) {
    return React__default.createElement(SBox, {
      className: "_STACKBOX_",
      gutter: hs,
      py: vs,
      width: el.props.width
    }, React__default.cloneElement(el, {
      width: "100%"
    }));
  }));
};

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n\n  ", "\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$8() {
  var data = _taggedTemplateLiteralLoose(["\n  /* Este height es para que podamos poner height: 100% o align-items: stretch\n  en los cards y as\xED ocupen todo el alto independientemente del contenido del\n  card */\n  ", "\n\n  & > div {\n    height: 100%;\n  }\n\n  ", "\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}

var cols = style({
  prop: "cols",
  cssProperty: "width",
  transformValue: function transformValue(n) {
    return 100 / n + "%";
  }
});
var GridItem = styled__default(Box)(_templateObject$8(), cols, system({
  s: {
    properties: ["paddingTop", "paddingLeft"],
    scale: "spacing"
  },
  vs: {
    property: "paddingTop",
    scale: "spacing"
  },
  hs: {
    property: "paddingLeft",
    scale: "spacing"
  }
}));
var SFlex$1 = styled__default(Flex)(_templateObject2$1(), system({
  s: {
    properties: ["marginTop", "marginLeft"],
    scale: "spacing",
    transform: function transform(v, s) {
      return s[v] !== undefined ? "-" + s[v] : "-" + v;
    }
  },
  vs: {
    property: "marginTop",
    scale: "spacing",
    transform: function transform(v, s) {
      return s[v] !== undefined ? "-" + s[v] : "-" + v;
    }
  },
  hs: {
    property: "marginLeft",
    scale: "spacing",
    transform: function transform(v, s) {
      return s[v] !== undefined ? "-" + s[v] : "-" + v;
    }
  }
}));

var StackCol = function StackCol(_ref) {
  var width = _ref.width,
      hs = _ref.hs,
      vs = _ref.vs,
      children = _ref.children,
      _ref$justifyContent = _ref.justifyContent,
      justifyContent = _ref$justifyContent === void 0 ? "flex-start" : _ref$justifyContent,
      _ref$alignItems = _ref.alignItems,
      alignItems = _ref$alignItems === void 0 ? "flex-start" : _ref$alignItems,
      props = _objectWithoutPropertiesLoose(_ref, ["width", "hs", "vs", "children", "justifyContent", "alignItems"]);

  return React__default.createElement(SFlex$1, _extends({
    flexDirection: "row",
    justifyContent: justifyContent,
    alignItems: alignItems
  }, props), React__default.Children.map(children, function (item, idx) {
    if (idx === children.length - 1) {
      return React__default.cloneElement(item);
    } else {
      return React__default.cloneElement(item, {
        pr: hs,
        pb: vs
      });
    }
  }));
};

function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  ", "\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$9() {
  var data = _taggedTemplateLiteralLoose(["\n  /* Este height es para que podamos poner height: 100% o align-items: stretch\n  en los cards y as\xED ocupen todo el alto independientemente del contenido del\n  card */\n  ", "\n\n  & > div {\n    height: 100%;\n  }\n\n  ", "\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}

var cols$1 = style({
  prop: "cols",
  cssProperty: "width",
  transformValue: function transformValue(n) {
    return 100 / n + "%";
  }
});
var GridItem$1 = styled__default(Box)(_templateObject$9(), cols$1, system({
  s: {
    properties: ["paddingTop", "paddingLeft"],
    scale: "spacing"
  },
  vs: {
    property: "paddingTop",
    scale: "spacing"
  },
  hs: {
    property: "paddingLeft",
    scale: "spacing"
  }
}));
var SFlex$2 = styled__default(Flex)(_templateObject2$2(), system({
  s: {
    properties: ["marginTop", "marginLeft"],
    scale: "spacing",
    transform: function transform(v, s) {
      return s[v] !== undefined ? "-" + s[v] : "-" + v;
    }
  },
  vs: {
    property: "marginTop",
    scale: "spacing",
    transform: function transform(v, s) {
      return s[v] !== undefined ? "-" + s[v] : "-" + v;
    }
  },
  hs: {
    property: "marginLeft",
    scale: "spacing",
    transform: function transform(v, s) {
      return s[v] !== undefined ? "-" + s[v] : "-" + v;
    }
  }
}));

var Columns = function Columns(_ref) {
  var cols = _ref.cols,
      width = _ref.width,
      hs = _ref.hs,
      vs = _ref.vs,
      children = _ref.children,
      _ref$justifyContent = _ref.justifyContent,
      justifyContent = _ref$justifyContent === void 0 ? "flex-start" : _ref$justifyContent,
      _ref$alignItems = _ref.alignItems,
      alignItems = _ref$alignItems === void 0 ? "flex-start" : _ref$alignItems,
      _ref$overflow = _ref.overflow,
      overflow = _ref$overflow === void 0 ? "hidden" : _ref$overflow,
      props = _objectWithoutPropertiesLoose(_ref, ["cols", "width", "hs", "vs", "children", "justifyContent", "alignItems", "overflow"]);

  return React__default.createElement(SFlex$2, _extends({
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: justifyContent,
    alignItems: alignItems,
    vs: vs ? vs : "",
    hs: hs ? hs : "",
    overflow: overflow
  }, props), !cols ? React__default.Children.map(children, function (item) {
    return React__default.cloneElement(item, {
      pl: hs,
      pt: vs
    });
  }) : React__default.Children.map(children, function (item, idx) {
    return React__default.createElement(GridItem$1, {
      cols: cols,
      width: width,
      vs: vs ? vs : "",
      hs: hs ? hs : "m",
      key: idx
    }, item);
  }));
};

function _templateObject$a() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}

var GridItem$2 = styled__default(Box)(_templateObject$a(), system({
  s: {
    properties: ["paddingTop", "paddingLeft"],
    scale: "spacing"
  },
  vs: {
    property: "paddingTop",
    scale: "spacing"
  },
  hs: {
    property: "paddingLeft",
    scale: "spacing"
  }
}));

var Column = function Column(_ref) {
  var _ref$justifyContent = _ref.justifyContent,
      _ref$alignItems = _ref.alignItems,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["justifyContent", "alignItems", "children"]);

  return React__default.createElement(GridItem$2, props, children);
};

var BreadCrumb = function BreadCrumb(_ref) {
  var children = _ref.children,
      _ref$separator = _ref.separator,
      separator = _ref$separator === void 0 ? "/" : _ref$separator,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "separator"]);

  var length = React__default.Children.count(children);
  return React__default.createElement(Flex, _extends({
    alignItems: "center",
    as: "ol"
  }, props), React__default.Children.map(children, function (element, idx) {
    return React__default.createElement(Flex, {
      as: "li",
      alignItems: "center"
    }, React__default.cloneElement(element), idx < length - 1 && separator);
  }));
};

function _templateObject$b() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  ", "\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}

var StyledButton = styled__default(Box).attrs(function (p) {
  return {
    as: p.as || "button"
  };
})(_templateObject$b(), function (p) {
  return p.loading && styled.css(["cursor:progress;"]);
});

var Button = function Button(_ref) {
  var loading = _ref.loading,
      loadingContent = _ref.loadingContent,
      disabled = _ref.disabled,
      children = _ref.children,
      focusable = _ref.focusable,
      href = _ref.href,
      props = _objectWithoutPropertiesLoose(_ref, ["loading", "loadingContent", "disabled", "children", "focusable", "href"]);

  return React__default.createElement(StyledButton, _extends({
    as: "button",
    href: href,
    role: "button",
    type: href ? null : "button",
    focusable: focusable,
    loading: loading,
    disabled: disabled ? focusable ? false : true : false,
    "aria-disabled": disabled
  }, props), loading ? loadingContent : children);
};

var CheckType = function CheckType(el, elType) {
  return el.type.target === elType || el.type === elType;
};

var Tabs = function Tabs(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  var _useState = React.useState(0),
      activeIndex = _useState[0],
      setActiveIndex = _useState[1];

  return React__default.createElement(Box, props, React.Children.map(children, function (element) {
    if (CheckType(element, Tabs.List)) {
      if (element !== null) {
        return React.cloneElement(element, {
          activeIndex: activeIndex,
          onActiveIndex: function onActiveIndex(activeIndex) {
            setActiveIndex(activeIndex);
          }
        });
      }
    } else if (CheckType(element, Tabs.Panels)) {
      if (element !== null) {
        return React.cloneElement(element, {
          activeIndex: activeIndex
        });
      }
    } else {
      if (element !== null) {
        return element;
      }
    }
  }));
}; // Tabs


Tabs.List = function (_ref2) {
  var children = _ref2.children,
      activeIndex = _ref2.activeIndex,
      onActiveIndex = _ref2.onActiveIndex,
      props = _objectWithoutPropertiesLoose(_ref2, ["children", "activeIndex", "onActiveIndex"]);

  return React__default.createElement(Box, props, React.Children.map(children, function (element, idx) {
    if (element !== null) {
      return React.cloneElement(element, {
        isActive: activeIndex === idx,
        onActivate: function onActivate() {
          return onActiveIndex(idx);
        }
      });
    }
  }));
};

Tabs.Tab = function (_ref3) {
  var children = _ref3.children,
      onActivate = _ref3.onActivate,
      isActive = _ref3.isActive,
      props = _objectWithoutPropertiesLoose(_ref3, ["children", "onActivate", "isActive"]);

  return React__default.createElement(Box, _extends({
    onClick: function onClick() {
      return onActivate();
    }
  }, props), children);
}; // Panels


Tabs.Panels = function (_ref4) {
  var children = _ref4.children,
      activeIndex = _ref4.activeIndex,
      props = _objectWithoutPropertiesLoose(_ref4, ["children", "activeIndex"]);

  return React__default.createElement(Box, props, children[activeIndex]);
};

Tabs.Panel = function (_ref5) {
  var children = _ref5.children,
      props = _objectWithoutPropertiesLoose(_ref5, ["children"]);

  return React__default.createElement(Box, props, children);
};

var VisuallyHidden = function VisuallyHidden(_ref) {
  var props = _extends({}, _ref);

  return React__default.createElement("span", _extends({
    style: {
      position: "absolute",
      clip: "rect(0 0 0 0)",
      overflow: "hidden",
      height: "1px",
      width: "1px",
      margin: "-1px",
      padding: 0,
      border: 0,
      whiteSpace: "nowrap",
      wordWrap: "normal"
    }
  }, props));
};

var index = {
  VisuallyHidden: VisuallyHidden,
  Flex: Flex,
  Box: Box,
  Columns: Columns,
  Column: Column,
  StackCol: StackCol,
  StackBox: StackBox,
  Stack: Stack,
  Inline: Inline,
  Anchor: Anchor,
  BreadCrumb: BreadCrumb,
  Button: Button,
  MaxWidth: MaxWidth,
  Image: Image,
  Normalize: Normalize,
  Text: Text,
  Truncate: Truncate,
  Tabs: Tabs
};
module.exports = index;